import axios from 'app/infrastructure/axiosInstance';
import { extractData, makeResource, QueryParams } from 'app/infrastructure/repository'
import { Service } from './_models';
import { Filters, IErrorResponse, IPagination, IValidationErrorResponse, Response, Sorters } from 'app/modules/tp/_apiResponse';
import * as config from 'app/configs/configs';

const SERVICE_ENDPOINT = 'services';

export default makeResource<Service>(SERVICE_ENDPOINT);
const baseApiUrl = config.getBaseApiUrl();
const apiUrl = `${baseApiUrl}/${SERVICE_ENDPOINT}`;

export const getFullByRideId = async (id: number, queryParams?: QueryParams | undefined) => {
    if (!id) {
        return;
    }
    return extractData(await axios.get<Response<Service>>(`${apiUrl}/ride/${id}`,
        { params: { ...queryParams } }
    ));
}

export const sendInvoice = (id: number) => {
    if (!id) {
        return;
    }
    axios.get(`${apiUrl}/invoiceNotify/${id}`)
}



